import {
  IAccountActivationParams,
  IChangeDefaultCompany,
  IForgotPasswordParams,
  ILoginParams,
  IRequestActivationTokenParams,
  IUpdateProfileParams,
  IUpdatePasswordParams,
} from '@/interfaces/api/user'
import { ICreateUser } from '@/interfaces/entities/user'
import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'

const UserResource = {
  login: (params: ILoginParams) => ApiService.post('v1/users/sign_in', params),
  signOut: () => ApiService.delete('v1/users/sign_out'),
  create: (params: ICreateUser) => ApiService.post('/v1/users', params),
  forgotPassword: (params: IForgotPasswordParams) => ApiService.put('v1/users/recovery_password', params),
  updatePassword: (params: IUpdatePasswordParams) => ApiService.put('v1/users/update_password', params),
  activateAccount: (params: IAccountActivationParams) => ApiService.post('v1/users/activate_account', params),
  getCompanies: () => ApiService.get(`/v1/users/companies`),
  getAllCompanies: () => ApiService.get(`/v1/users/all_companies`),
  getProfileData: () => ApiService.get('/v1/users/profile_data'),
  show: (id: number) => ApiService.get(`/v1/users/${id}`),
  update: (params: IUpdateProfileParams) => ApiService.put(`/v1/users/${params.id}`, params),
  getCompanyUsers: (companyId?: number) =>
    ApiService.get(`/v1/companies/${companyId ?? getCurrentCompanyId()}/view_users_company`),
  getUsers: () => ApiService.get('/v1/users'),
  removeUser: (userId: number) => ApiService.delete(`/v1/users/${userId}`),
  createCompanyUser: (params: ICreateUser) => ApiService.post('/v1/users/create_company_user', params),
  getCompanyMqttBrokers: () => ApiService.get(`/v1/companies/${getCurrentCompanyId()}/mqtt_brokers`),
  requestActivationToken: (params: IRequestActivationTokenParams) => ApiService.post('v1/users/request_activation_token', params),
  changeDefaultCompany: (params: IChangeDefaultCompany) => ApiService.post('v1/users/change_user_default_company', params),

  getCompanyShifts: () => ApiService.get(`v1/companies/${getCurrentCompanyId()}/shifts`),
  getCompanyUserDetail: (companyId: number, userId: number) =>
    ApiService.get(`v1/companies/${companyId}/users/${userId}`),

  uploadAvatar: (userId: number, file: File) => {
    const formData = new FormData()
    formData.append('avatar', file)
    return ApiService.put(`/v1/users/${userId}`, formData, {
      'Content-Type': 'multipart/form-data',
    })
  },
  removeAvatar: (userId: number) =>
    ApiService.put(`/v1/users/${userId}`, { remove_avatar: '1' }),
}

export default UserResource
